import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import { validFielddHelper } from '../helpers/ValidFieldsHelper';
import * as CONST from '../constants/FieldsConst';

function sleep(delay = 0) {
  return new Promise((resolve) => {
    setTimeout(resolve, delay);
  });
}

const SelectAutocomplete = ({
  v,
  onChange,
  ht,
  e,
  opt,
  l,
  id,
  type,
  required = false,
}) => {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;

  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      await sleep(1e3); // For demo purposes.

      if (active) {
        setOptions([...opt]);
      }
    })();

    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  const label = (o) => {
    try {
      let x = o.nombre;

      switch (type) {
        case CONST.seccion.name:
          x = `${o.nivelAcademico.nivelAcademico.abrev}-${o.nombre}-${o.turno} `;
          break;
        case CONST.docente.name:
          x = `${o.usuario.perfil.pnombre} ${o.usuario.perfil.papellido}`;
          break;
        case CONST.periodoAcademico.name:
          x = `${o.nombre} (${o.desde}-${o.hasta})`;
          break;
        case CONST.carrera.name:
          x = `${o.carrera.nombre ?? o.nombre}`;
          break;
        default:
          break;
      }

      return x;
    } catch (error) {
      return '';
    }
  };

  return (
    <Autocomplete
      id={id}
      // value={v}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => label(option)}
      options={opt}
      loading={loading}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={l}
          size="small"
          error={e}
          helperText={ht ?? e ? validFielddHelper(1) : null}
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default SelectAutocomplete;
